import { Modal } from 'antd';
import { lighten } from 'polished';
import styled from 'styled-components';

const COLOR_PRIMARY = '#F78E1E';
const COLOR_TEXT = '#263238';
const COLOR_MUTED = '#8C8C8C';
const COLOR_BORDER = '#E8EAED';
const COLOR_SURFACE_ALT = '#FBFCFE';

export const SettingsModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 12px;
    overflow: hidden;
  }

  .ant-modal-header {
    border-bottom: 1px solid ${COLOR_BORDER};
  }

  .ant-modal-title {
    font: 16px 'Roboto', sans-serif;
    font-weight: 600;
    color: ${COLOR_TEXT};
  }

  .ant-modal-body {
    padding: 16px 24px;
  }

  .ant-modal-footer {
    border-top: 1px solid ${COLOR_BORDER};
    padding: 12px 24px;
  }

  @media (max-width: 599px) {
    .ant-modal-body {
      padding: 16px;
    }

    .ant-modal-footer {
      padding: 12px 16px;
    }
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;

  .ant-btn {
    margin: 0;
  }

  @media (max-width: 599px) {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }
`;

export const FooterLinkButton = styled.div`
  .ant-btn-link {
    padding-left: 0;
    color: ${COLOR_PRIMARY};
    border-color: transparent;
    background-color: transparent;
    box-shadow: none;

    &:hover,
    &:focus,
    &:active {
      color: ${lighten(0.08, COLOR_PRIMARY)};
      border-color: transparent;
      background-color: transparent;
      box-shadow: none;
      text-decoration: underline;
    }
  }

  @media (max-width: 599px) {
    order: 2;
    text-align: center;

    .ant-btn-link {
      padding-left: 15px;
    }
  }
`;

export const FooterActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  @media (max-width: 599px) {
    order: 1;

    .ant-btn {
      flex: 1;
      height: 40px;
    }
  }
`;

export const SettingsHint = styled.p`
  font: 12px 'Roboto', sans-serif;
  color: ${COLOR_MUTED};
  margin: 12px 0 8px 0;
`;

export const OptionList = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 320px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #d9d9d9;
    border-radius: 3px;
  }
`;

export const Option = styled.div`
  border-radius: 8px;

  &:hover {
    background-color: ${COLOR_SURFACE_ALT};
  }

  &[data-disabled='true'] {
    opacity: 0.45;
  }

  .ant-checkbox-wrapper {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 10px 8px;
    margin: 0;
  }

  .ant-checkbox + span {
    display: flex;
    min-width: 0;
    padding-right: 0;
  }
`;

export const OptionTexts = styled.span`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const OptionTitle = styled.span`
  font: 13px 'Roboto', sans-serif;
  color: ${COLOR_TEXT};
`;

export const OptionParent = styled.span`
  font: 11px 'Roboto', sans-serif;
  color: ${COLOR_MUTED};
`;

export const EmptyOptions = styled.p`
  font: 13px 'Roboto', sans-serif;
  color: ${COLOR_MUTED};
  text-align: center;
  padding: 24px 0;
  margin: 0;
`;
